"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarCell = void 0;
var calendar_1 = require("@react-aria/calendar");
var react_1 = __importStar(require("react"));
var Calendar_styled_1 = require("./Calendar.styled");
function CalendarCell(_a) {
    var state = _a.state, date = _a.date;
    var ref = (0, react_1.createRef)();
    var _b = (0, calendar_1.useCalendarCell)({ date: date }, state, ref), cellProps = _b.cellProps, buttonProps = _b.buttonProps, isSelected = _b.isSelected, isOutsideVisibleRange = _b.isOutsideVisibleRange, isDisabled = _b.isDisabled, isUnavailable = _b.isUnavailable, formattedDate = _b.formattedDate;
    return (react_1.default.createElement(Calendar_styled_1.StyledCalendarTd, __assign({}, cellProps),
        react_1.default.createElement(Calendar_styled_1.StyledCalendarCell, __assign({}, buttonProps, { "data-testid": "calendar-cell-".concat(formattedDate), ref: ref, hidden: isOutsideVisibleRange, isSelected: isSelected, isDisabled: isDisabled, isUnavailable: isUnavailable }), formattedDate)));
}
exports.CalendarCell = CalendarCell;
